import type { InventoryVehicle } from '@carvana/merch-contracts';
import TrackWrapper from '@/common/TrackWrapper';
import { useFavoritesIds } from '~/context/common/UserContext';
import { useRequestIds } from '~/context/srp/InventoryContext';
import getTileWrapperProps from '~/utilities/srp/getTileWrapperProps';
import VehicleTile from '../../VehicleTile';

type OwnProps = {
  vehicles: InventoryVehicle[];
};

export default function SimilarResults({ vehicles }: OwnProps) {
  const favoriteIds = useFavoritesIds();
  const requestIds = useRequestIds();

  return (
    <>
      {vehicles.map((v, index) => {
        const vehicle: InventoryVehicle = {
          ...v,
          isFavorite: favoriteIds.includes(v.vehicleId),
          isSimilarTile: true
        };

        const wrapperProps = getTileWrapperProps({
          index,
          isConditionalTile: false,
          isSimilarVehicle: true,
          totalTiles: vehicles.length,
          ...requestIds
        });

        return (
          <TrackWrapper key={vehicle.vehicleId} {...wrapperProps}>
            <VehicleTile vehicle={vehicle} />
          </TrackWrapper>
        );
      })}
    </>
  );
}
